import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { isEventNotificationDetails } from "@scrile/api-provider/dist/projects/scrileConnect/EventPostProvider";
import { $t } from "@/lib/i18nHelpers";
import { getLiveUrl, getProfileUrl } from "@/lib/urlHelpers";
import router from "@/router";
import { NotificationData } from "@/types";

export default function(notification: Notification): NotificationData | false {
  const user = notification.user;

  if (isEventNotificationDetails(notification.details) && user) {
    if (notification.type === NotificationType.EVENT_PUBLISHED) {
      return {
        text: $t("Upcoming event by {0}!", [user?.screenName]),
        position: "top",
        timeout: 7000,
        image: {
          user: user,
        },
        onNotificationClick: () => router.push(getProfileUrl(user.id, { feedId: notification.details.event.postId })),
      };
    } else if (notification.type === NotificationType.EVENT_STARTED) {
      return {
        text: $t("The event has started"),
        position: "top",
        timeout: 7000,
        image: {
          user: user,
        },
        onNotificationClick: () => router.push(getLiveUrl(user)),
      };
    }
  }
  return false;
}
